import { render } from "./InfoContactModule.vue?vue&type=template&id=df9c917c&scoped=true"
import script from "./InfoContactModule.vue?vue&type=script&lang=js"
export * from "./InfoContactModule.vue?vue&type=script&lang=js"

import "./InfoContactModule.vue?vue&type=style&index=0&id=df9c917c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df9c917c"]])

export default __exports__